import { render } from "./vprintreSourcesMarklist.vue?vue&type=template&id=5063d7d2&scoped=true"
import script from "./vprintreSourcesMarklist.vue?vue&type=script&lang=js"
export * from "./vprintreSourcesMarklist.vue?vue&type=script&lang=js"

import "./vprintreSourcesMarklist.vue?vue&type=style&index=0&id=5063d7d2&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/生产环境总后台manage.jsyinba.com/jsgeneral/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5063d7d2"]])

export default __exports__